/**
 * Created by JasonChou on 17/6/14.
 */
import React, {PureComponent} from 'react'
import NetImage from './NetImage';

export default class Avatar extends PureComponent {
    render() {
        const {style, diameter = 60, defSource, ...other} = this.props;

        if (!other.source || !other.source.uri) {
            if (!defSource)
                other.source = require('../apps/question/assets/ic_avatar_default.png');
            else
                other.source = defSource;
        }

        return <NetImage
            style={Object.assign({
                width: diameter,
                height: diameter,
                borderRadius: diameter / 2,
                backgroundColor: '#ddd'
            }, style)} {...other} w={diameter} h={diameter}/>
    }
}


// WEBPACK FOOTER //
// ./src/components/Avatar.js